import React from 'react';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import LinearProgress from '@material-ui/core/LinearProgress';
import Button from '@material-ui/core/Button';
import Pagination from '@material-ui/lab/Pagination';
import { CORES } from '../theme';

/**
 * Tabela padrão das listagens: cabeçalho, carregamento, estado vazio e paginação com contador.
 *
 * <TabelaPaginada
 *   colunas={[{ titulo: "Nome" }, { titulo: "Ações", align: "right" }]}
 *   carregando={loading}
 *   vazio={rows.length === 0}
 *   textoVazio="Nenhum cliente encontrado"
 *   temFiltro={temFiltro} onLimpar={limpar}
 *   pagina={page} totalPaginas={n} totalRegistros={total} porPagina={25} onPagina={setPage}
 * >
 *   {rows.map(...)}  // <TableRow>s
 * </TabelaPaginada>
 */
const TabelaPaginada = ({
    colunas,
    children,
    carregando,
    vazio,
    textoVazio = 'Nenhum registro encontrado',
    temFiltro,
    onLimpar,
    pagina,
    totalPaginas,
    totalRegistros,
    porPagina,
    onPagina,
    rotulo,
}) => (
    <>
        <div style={{ height: 4 }}>{carregando && <LinearProgress />}</div>
        <Paper variant="outlined" style={{ overflowX: 'auto' }}>
            <Table aria-label={rotulo}>
                <TableHead>
                    <TableRow>
                        {colunas.map((c) => (
                            <TableCell
                                key={c.titulo}
                                align={c.align || 'left'}
                                style={{ background: '#62605A', color: '#fff', fontWeight: 600, whiteSpace: 'nowrap' }}
                            >
                                {c.titulo}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {!carregando && vazio && (
                        <TableRow>
                            <TableCell colSpan={colunas.length} align="center" style={{ padding: 40, color: CORES.textoSuave }}>
                                {textoVazio}{temFiltro ? ' com esses filtros.' : '.'}
                                {temFiltro && onLimpar && <> <Button size="small" onClick={onLimpar}>Limpar filtros</Button></>}
                            </TableCell>
                        </TableRow>
                    )}
                    {children}
                </TableBody>
            </Table>
        </Paper>
        {totalRegistros > 0 && (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', justifyContent: 'space-between', padding: '12px 0' }}>
                <span style={{ fontSize: 13, color: CORES.textoSuave }}>
                    {porPagina
                        ? `${(pagina - 1) * porPagina + 1}–${Math.min(pagina * porPagina, totalRegistros)} de ${totalRegistros}`
                        : `${totalRegistros} ${totalRegistros === 1 ? 'registro' : 'registros'}`}
                </span>
                {totalPaginas > 1 && (
                    <Pagination count={totalPaginas} page={pagina} onChange={(e, v) => onPagina(v)} color="primary" />
                )}
            </div>
        )}
    </>
);

/** Lê a resposta paginada do Laravel ({ data, total, per_page, last_page }) ou uma lista simples. */
export const lerPaginacao = (resposta, porPaginaPadrao) => {
    const corpo = resposta && resposta.data !== undefined ? resposta.data : resposta;
    if (Array.isArray(corpo)) {
        return { linhas: corpo, total: corpo.length, porPagina: null, totalPaginas: 1 };
    }
    const linhas = (corpo && Array.isArray(corpo.data)) ? corpo.data : [];
    const total = corpo && corpo.total !== undefined ? Number(corpo.total) : linhas.length;
    const porPagina = corpo && corpo.per_page ? Number(corpo.per_page) : porPaginaPadrao;
    const totalPaginas = corpo && corpo.last_page
        ? Number(corpo.last_page)
        : Math.max(1, Math.ceil(total / (porPagina || total || 1)));
    return { linhas, total, porPagina, totalPaginas };
};

export default TabelaPaginada;
